/* OBSYN – Produit 3D : inclinaison 3D, changement de vue au mouvement, choix de taille */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function init(sec) {
    if (sec.dataset.obP3dInit) return;
    sec.dataset.obP3dInit = '1';
    const stage = sec.querySelector('[data-ob-p3d-stage]');
    const card = sec.querySelector('[data-ob-p3d-card]');
    if (!stage || !card) return;
    const views = [...card.querySelectorAll('[data-ob-view]')];
    const tabs = [...sec.querySelectorAll('[data-ob-view-btn]')];
    let view = 0;
    let tx = 0, ty = 0, cx = 0, cy = 0;
    let lastInteract = 0;
    let visible = false;
    let dragX = null, dragStart = 0;

    const setView = (i, dir) => {
      i = (i + views.length) % views.length;
      if (i === view) return;
      const d = dir || (i > view ? 1 : -1);
      views.forEach((v, k) => {
        v.style.setProperty('--enter', `${d * (k === i ? -35 : 35)}deg`);
        v.classList.toggle('is-active', k === i);
      });
      tabs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
      card.dataset.view = i;
      view = i;
    };
    card.dataset.view = 0;

    tabs.forEach((t) => t.addEventListener('click', (e) => {
      e.stopPropagation();
      lastInteract = performance.now() + 6000;
      setView(parseInt(t.dataset.obViewBtn, 10));
    }));

    stage.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const r = stage.getBoundingClientRect();
      const nx = ((e.clientX - r.left) / r.width) * 2 - 1;
      const ny = ((e.clientY - r.top) / r.height) * 2 - 1;
      tx = ny * -7;
      ty = nx * 14;
      lastInteract = performance.now();
      card.style.setProperty('--gx', `${50 + nx * 40}%`);
      card.style.setProperty('--gy', `${35 + ny * 30}%`);
      if (nx < -0.5) setView(1, -1);
      else if (nx > 0.5) setView(2, 1);
      else if (Math.abs(nx) < 0.3) setView(0, nx < 0 ? 1 : -1);
    });
    stage.addEventListener('pointerleave', () => { tx = 0; ty = 0; });

    stage.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      dragX = e.clientX; dragStart = e.clientX;
      lastInteract = performance.now() + 4000;
    });
    stage.addEventListener('pointermove', (e) => {
      if (dragX === null || e.pointerType === 'mouse') return;
      ty = Math.max(-25, Math.min(25, (e.clientX - dragStart) * 0.25));
      lastInteract = performance.now() + 4000;
    });
    const endDrag = (e) => {
      if (dragX === null) return;
      const dx = e.clientX - dragStart;
      if (Math.abs(dx) > 40) setView(view + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      dragX = null; ty = 0;
    };
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    if (!finePointer && 'DeviceOrientationEvent' in window && typeof DeviceOrientationEvent.requestPermission !== 'function') {
      window.addEventListener('deviceorientation', (e) => {
        if (!visible || e.gamma == null || dragX !== null) return;
        ty = Math.max(-18, Math.min(18, e.gamma * 0.6));
        tx = Math.max(-8, Math.min(8, (e.beta - 45) * -0.25));
        lastInteract = performance.now();
      });
    }

    new IntersectionObserver((en) => { visible = en[0].isIntersecting; }, { threshold: 0.15 }).observe(stage);

    let lastAuto = performance.now();
    const word = sec.querySelector('.ob-p3d__word');
    const shadow = sec.querySelector('.ob-p3d__shadow');
    const tick = (now) => {
      if (visible && !reduce) {
        const idle = now - lastInteract > 2500;
        let gx = tx, gy = ty;
        if (idle) {
          gy = Math.sin(now / 1400) * 8;
          gx = Math.sin(now / 2100) * 3;
          if (!finePointer && now - lastAuto > 3500) { setView(view + 1, 1); lastAuto = now; }
        } else lastAuto = now;
        cx += (gx - cx) * 0.08;
        cy += (gy - cy) * 0.08;
        card.style.setProperty('--rx', `${cx.toFixed(2)}deg`);
        card.style.setProperty('--ry', `${cy.toFixed(2)}deg`);
        if (word) word.style.setProperty('--wx', `${(-cy * 3).toFixed(1)}px`);
        if (shadow) {
          shadow.style.setProperty('--sx', `${(cy * 1.6).toFixed(1)}px`);
          shadow.style.setProperty('--ss', (1 - Math.abs(cy) / 90).toFixed(3));
        }
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    const form = sec.querySelector('[data-ob-p3d-form]');
    if (form) {
      const input = form.querySelector('[data-ob-variant]');
      const err = form.querySelector('[data-ob-size-error]');
      form.querySelectorAll('[data-ob-size]').forEach((b) => b.addEventListener('click', () => {
        form.querySelectorAll('[data-ob-size]').forEach((x) => x.classList.toggle('is-selected', x === b));
        input.value = b.dataset.obSize;
        form.classList.remove('has-error');
        if (err) err.hidden = true;
      }));
      form.addEventListener('submit', (e) => {
        if (!input.value) {
          e.preventDefault();
          form.classList.add('has-error');
          if (err) err.hidden = false;
        }
      });
    }
  }

  const boot = (scope = document) => scope.querySelectorAll('[data-ob-p3d]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
